/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    component: {
        statusIndicator: {
            paddingHorizontal: {
                value: "8px",
                type: "dimension",
            },
            paddingVertical: {
                value: "4px",
                type: "dimension",
            },
            borderRadius: {
                value: "4px",
                type: "dimension",
            },
            fontWeight: {
                value: 600,
                type: "fontWeight",
            },
            fontSize: {
                value: "0.75rem",
                type: "dimension",
            },
            lineHeight: {
                value: "1rem",
                type: "dimension",
            },
            letterSpacing: {
                value: "1px",
            },
            textTransform: {
                value: "uppercase",
            },
            color: {
                success: {
                    backgroundColor: {
                        value: "#05704B",
                        type: "color",
                    },
                },
                alert: {
                    backgroundColor: {
                        value: "#EAA14B",
                        type: "color",
                    },
                    color: {
                        value: "#1e1e1e",
                        type: "color",
                    },
                },
                error: {
                    backgroundColor: {
                        value: "#AF292E",
                        type: "color",
                    },
                },
                notification: {
                    backgroundColor: {
                        value: "#385F99",
                        type: "color",
                    },
                },
                disabled: {
                    backgroundColor: {
                        value: "#676767",
                        type: "color",
                    },
                },
            },
            height: {
                value: "24px",
                type: "dimension",
            },
        },
    },
};
export default tokens;
